export const finishAnsweringTooltip = 'Oops! Please finish answering this question to proceed.';

export type TooltipClassType = null | 'invalid-state' | 'confirmation-warning';
